export const OPEN_AI_CHAT_EVENT = 'enterweu:open-ai-chat';

export const ASSISTANT_URL = '/api/users/assistant/message/';

export const CHATBOT_UNREACHABLE =
  "I couldn't reach the assistant. Open Interview Modes or Help & Support.";

export const CHAT_WELCOME = {
  public:
    "I can explain the seven interview modes, how a job description recommends one mode, how scores stay on the candidate, talent search (one city + one role family), and simulate vs Razorpay. What do you need?",
  register:
    "Pick candidate, consultancy, or institution. After you join, Interview Modes, persisted scores, and subscriptions are available. Students are not listed for sale.",
  app:
    "Ask about your mode scores, the JD's one recommended mode, talent unlock (one city + one role family), Settings (name, email, phone), or simulate vs Razorpay.",
};

export const CHAT_SUGGESTIONS = {
  public: [
    'What are the seven interview modes?',
    'Does a job description pick a mode for me?',
    'How do payments work here?',
    'What is talent search?',
  ],
  register: [
    'Which account type should I choose?',
    'What are the seven interview modes?',
    'How do payments work here?',
  ],
  app: [
    'Where are my mode scores saved?',
    'How does the JD recommend a mode?',
    'How does talent search unlock?',
    'Simulate vs Razorpay — what is charged?',
  ],
};

export const openAiChatSupport = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OPEN_AI_CHAT_EVENT));
};

export function parseChatbotReply(data, ok = true) {
  const text = data && data.response != null ? String(data.response).trim() : '';
  if (ok && data && data.success && text) {
    return {
      text,
      conversationId: data.conversation_id || '',
      live: data.live !== false,
    };
  }
  return {
    text: CHATBOT_UNREACHABLE,
    conversationId: (data && data.conversation_id) || '',
    live: false,
  };
}

export async function sendChatbotMessage({ message, conversationId, userId } = {}) {
  const text = (message || '').trim();
  if (!text) {
    return parseChatbotReply({}, false);
  }
  const headers = { 'Content-Type': 'application/json' };
  const body = {
    user_id: userId ? String(userId) : 'web_user',
    message: text,
  };
  if (conversationId) body.conversation_id = conversationId;
  try {
    const res = await fetch(ASSISTANT_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    });
    let data = {};
    try {
      data = await res.json();
    } catch {
      data = {};
    }
    return parseChatbotReply(data, res.ok);
  } catch {
    return parseChatbotReply({}, false);
  }
}
